import { FolderOpen, Plus, Sparkles, Lightbulb } from "lucide-react";

interface ProjectsEmptyViewProps {
  onStart: () => void;
}

export function ProjectsEmptyView({ onStart }: ProjectsEmptyViewProps) {
  return (
    <>
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <span>Project Setup</span>
        <span className="breadcrumb__sep" aria-hidden="true">·</span>
        <span className="breadcrumb__current">Workflow</span>
      </nav>
      <div className="page-header" style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 16 }}>
        <div>
          <h2 className="page-header__title">Projects</h2>
          <p className="page-header__description">Stand up a new Spend Intelligence engagement in four guided steps.</p>
        </div>
      </div>

      <div className="empty-state">
        <div className="empty-state__visual" aria-hidden="true">
          <div className="empty-state__icon-box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="#8EC5FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 5V19" stroke="#8EC5FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          {/* <span className="empty-state__float empty-state__float--tl">
            <Sparkles size={18} color="var(--brand-purple)" />
          </span>
          <span className="empty-state__float empty-state__float--tr">
            <Lightbulb size={18} color="var(--brand-pink)" />
          </span> */}
        </div>
        <h3 className="empty-state__title">No projects found</h3>
        <p className="empty-state__description">
          Try adjusting your search or create a new project
        </p>
        <button type="button" className="btn btn--primary" onClick={onStart}>
          <Plus size={14} aria-hidden="true" /> Create New Project
        </button>
      </div>
    </>
  );
}
